export const formatDate = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

export const  convertirDateEnFrancais = (dateString) => {
  // Tableau des noms des mois en français
  const mois = [
    'janvier', 'février', 'mars', 'avril', 'mai', 'juin',
    'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'
  ];

  // Divise la chaîne de date en parties (année, mois, jour)
  const [annee, moisIndex, jour] = dateString.split('-');

  // Assure que les parties sont des nombres et que l'index du mois est valide
  const index = parseInt(moisIndex, 10) - 1;
  if (isNaN(index) || index < 0 || index > 11) {
    return 'Date invalide';
  }

  // Combine le jour, le nom du mois et l'année pour le format final
  const moisNom = mois[index];
  return `${jour} ${moisNom} ${annee}`;
}

export const  advancedFormat = (startDateString, endDateString) => {
  // Tableau des noms des mois en français
  const mois = [
    'janvier', 'février', 'mars', 'avril', 'mai', 'juin',
    'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'
  ];

  // Fonction pour formater une seule date
  const formaterDate = (dateString) => {
    const [annee, moisIndex, jour] = dateString.split('-');
    const index = parseInt(moisIndex, 10) - 1;
    if (isNaN(index) || index < 0 || index > 11) {
      return 'Date invalide';
    }
    const moisNom = mois[index];
    return `${jour} ${moisNom} ${annee}`;
  };

  // Si la date de fin n'est pas fournie ou est identique à la date de début
  if (!endDateString || startDateString === endDateString) {
    return formaterDate(startDateString);
  }

  // Divise les dates en parties pour la comparaison
  const [startAnnee, startMois, startJour] = startDateString.split('-');
  const [endAnnee, endMois, endJour] = endDateString.split('-');

  const startMoisNom = mois[parseInt(startMois, 10) - 1];
  const endMoisNom = mois[parseInt(endMois, 10) - 1];

  // Cas 1: Même mois et même année
  if (startMois === endMois && startAnnee === endAnnee) {
    return `${startJour} au ${endJour} ${endMoisNom} ${endAnnee}`;
  } 
  // Cas 2: Année identique, mais mois différent
  else if (startAnnee === endAnnee) {
    return `${startJour} ${startMoisNom} au ${endJour} ${endMoisNom} ${endAnnee}`;
  } 
  // Cas 3: Années différentes
  else {
    return `${startJour} ${startMoisNom} ${startAnnee} au ${endJour} ${endMoisNom} ${endAnnee}`;
  }
}